import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ModalGestionBusComponent } from './modal-gestion-bus/modal-gestion-bus.component';
import { ApiService } from '../services/api.service';
import { MovilDTO } from '../../dtos/movil.dto';
import { AppMessage } from '../app.message';
import { CommonModule } from "@angular/common";
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { GetListaMovilesResponseDTO } from '../../dtos/response/getListaBuses.response.dto';
import { MovilService } from '../services/movil.service';
import moment from "moment";
import { FormsModule } from '@angular/forms';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { NgSelectModule } from '@ng-select/ng-select';
import { SucursalService } from '../services/sucursal.service';
import { EventService } from '../services/event.service';
import { CambiarSucursalComponent } from '../modals/cambiar-sucursal/cambiar-sucursal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {ConfigMqttService} from "../services/configMqtt.service";
import {IMqttMessage} from "ngx-mqtt";
import {skip, Subscription} from "rxjs";
import {GetDetalleMovilResponseDTO} from "../../dtos/response/getDetalleMovil.response.dto";


@Component({
  selector: 'app-gestion-buses',
  standalone: true,
  imports: [CommonModule, InfiniteScrollDirective, FormsModule, ProgressbarModule, NgSelectModule, TooltipModule],
  templateUrl: './gestion-buses.component.html',
  styleUrl: './gestion-buses.component.scss'
})
export class GestionBusesComponent implements OnInit, OnDestroy {

  filtroColap: boolean = false;

  movilesPorEstado = {
    DISPONIBLE: [],
    EN_CURSO: [],
    EN_LAVADO: [],
    EN_CARGA: [],
    EN_TALLER: [],
    ASIGNADO: [],
    CONFIRMADO: [],
    // NO_DISPONIBLE: []
  };

  porcentajesPorEstado = {
    DISPONIBLE: '0%',
    EN_CURSO: '0%',
    EN_LAVADO: '0%',
    EN_CARGA: '0%',
    EN_TALLER: '0%',
    ASIGNADO: '0%',
    CONFIRMADO: '0%',
    ASIGNADO_CONFIRMADO: '0%',
    // NO_DISPONIBLE: '0%'
  };

  public modoEstandar: boolean = true;
  public listaMoviles: Array<MovilDTO> = [];
  private pageSize: number = 1000000;
  private page: number = 0;
  private hasNext: boolean = false;

  public intervaloProgressBar: any;
  private intervalReloj: any;
  private sucursalesSub: Subscription;

  public rangoCargaMin: number = 0;
  public rangoCargaMax: number = 100;

  cargaElectricaMinima: number = 0;
  cargaElectricaMaxima: number = 100;

  // Para recordar el valor anterior
  valorMinimoPrevio: number = 0;
  valorMaximoPrevio: number = 100;

  public contador: number = 0;
  public recarga = 900000;
  recargas = [
    { label: 'Off', value: 0 },
    { label: '15 minutos', value: 900000 },
  ];

  public desactivarInfiniteScroll: boolean = true;
  public horaActual: string = "Cargando";
  public tipoSeleccionado: string = 'Todos';
  public unidadSeleccionada: string = 'Todos';
  public tipoBus: string = 'Todos';
  public textoBusqueda: string = '';
  public sucursalesSelectedNombres: string = '';
  public sucursalesSelectedNombresLargos: string = '';
  private listadoSuscripcionesMovilesMtt: {[key: string] : Subscription} = {};
  public listadoMovilesEstadosModificadosPorMqtt: Array<string> = [];
  public listadoMovilesEstadosModificadosPorMqttFadeOut: Array<string> = [];
  private pendingMqttUpdates: {[uuid: string]: any} = {};

  constructor(private modalService: BsModalService, private apiService: ApiService, private movilService: MovilService,
    private sucursalService : SucursalService, private eventService: EventService, 
    private configMqttService: ConfigMqttService,   private zone: NgZone,
    private cd: ChangeDetectorRef, private toastr: ToastrService) {
  }

  ngOnDestroy() {
    clearInterval(this.intervaloProgressBar);
    clearInterval(this.intervalReloj);
    this.sucursalesSub?.unsubscribe();
    this.cancelarMqttUpdatesPendientes();
    this.unsubscribeMqtt();
  }

  ngOnInit(): void {
    this.calcularTime()
    this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
    this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
    this.horaActual = moment().format("HH:mm:ss");


    this.zone.runOutsideAngular(() => {
      this.intervalReloj = setInterval(() => {
        const nuevaHora = moment().format("HH:mm:ss");
        this.zone.run(() => {
          this.horaActual = nuevaHora;
        });
      }, 1000);
    });

    this.initSuscripcionesEventos();
    if(!this.sucursalService.getSucursalesSeleccionadas() || this.sucursalService.getSucursalesSeleccionadas().length == 0) {
      this.toastr.warning('Debe seleccionar alguna sucursal', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }
    this.getListaMoviles();
  }

  onMinChange(valor: number) {
    console.log({nuevoValor: valor, antiguoValor: this.cargaElectricaMinima })
    if (valor <= this.cargaElectricaMaxima) {
      this.cargaElectricaMinima = valor;
      this.valorMinimoPrevio = valor;
      this.actualizarListasFiltradas();
    } else {
      // Revertir visualmente el slider si pasó del máximo permitido
      this.cargaElectricaMinima = this.valorMinimoPrevio;
    }
  }

  onMaxChange(valor: number) {
    console.log({nuevoValor: valor, antiguoValor: this.cargaElectricaMinima })
    if (valor >= this.cargaElectricaMinima) {
      this.cargaElectricaMaxima = valor;
      this.valorMaximoPrevio = valor;
      this.actualizarListasFiltradas();
    } else {
      this.cargaElectricaMaxima = this.valorMaximoPrevio;
    }
  }

  reload(){
    this.calcularTime();
    this.getListaMoviles();
  }

  initSuscripcionesEventos() {
    this.sucursalesSub = this.sucursalService.sucursales$.pipe(skip(1)).subscribe(() => {
      this.sucursalesSelectedNombres = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto();
      this.sucursalesSelectedNombresLargos = this.sucursalService.getSucursalesNombresSeleccionadasComoTexto(true);
      this.getListaMoviles();
    })
    this.eventService.subscribe('CAMBIAR_ESTADO_MOVILES_EVENT', () => {
      this.getListaMoviles();
    })
    this.eventService.subscribe('EXTENDER_TIEMPO_MOVILES_EVENT', () => {
      this.getListaMoviles();
    })
  }

  openModalCambiarSucursal() {
    this.modalService.show(CambiarSucursalComponent, {
      ignoreBackdropClick: false,
      keyboard: true,
      class: 'modal-dialog-centered modal-md'
    });
  }

  getListaMoviles() {
    this.apiService.getListaMoviles(
      this.page,
      this.pageSize,
      this.sucursalService.getSucursalesUUIDSeleccionadasComoTexto()).subscribe(
        (resp) => this.getListaMovilesSuccess(resp),
        (error) => this.getListaMovilesError(error),
      );
  }

  getListaMovilesSuccess(getListaMovilesResponseDTO: GetListaMovilesResponseDTO) {
    console.log('exito lista viajes', getListaMovilesResponseDTO);
    this.cancelarMqttUpdatesPendientes();
    this.listaMoviles = getListaMovilesResponseDTO.data.list;
    this.actualizarListasFiltradas();
    this.initSuscripcionesMqtt();
    /*
    this.hasNext = getListaMovilesResponseDTO.data.hasNext;
    if (this.hasNext) {
      this.desactivarInfiniteScroll = false;
      this.page++;
      return;
    }
    this.desactivarInfiniteScroll = true;
    */
  }


  initSuscripcionesMqtt() {
    console.log('init suscripicon mqtt');
    this.listaMoviles.forEach((movil) => {
      if(!this.listadoSuscripcionesMovilesMtt[movil.numeroInterno]) {
        this.listadoSuscripcionesMovilesMtt[movil.numeroInterno] = this.configMqttService.subscribeTopicMovil(movil.numeroInterno).subscribe((mqttMessage: IMqttMessage) => {
          const json = JSON.parse(mqttMessage.payload.toString());
          //console.log('message mqtt', json.numeroInterno);
          const indice = this.listaMoviles.findIndex(movil => (movil.numeroInterno === json.numeroInterno) && (movil.version < json.version));
          if(indice !== -1)
            this.getDetalleMovil(json.numeroInterno);
        });
      }
    })
  }

  onFiltroCambio(){
    this.actualizarListasFiltradas();
  }

  actualizarListasFiltradas() {
    const filtrados = this.filtrarMovilesPorFiltro();

    this.movilesPorEstado = {
      DISPONIBLE: [],
      EN_CURSO: [],
      EN_LAVADO: [],
      EN_CARGA: [],
      EN_TALLER: [],
      ASIGNADO: [],
      CONFIRMADO: [],
      // NO_DISPONIBLE: []
    };

    filtrados.forEach(movil => {
      const lista = this.movilesPorEstado[movil.estado];
      if (lista) {
        lista.push(movil);
      }
    });

    for (const estado in this.movilesPorEstado) {
      this.movilesPorEstado[estado].sort((a, b) => {
        const ahora = moment();
        const tiempoA = ahora.diff(moment.utc(a.estadoFechaInicio).local(), 'minutes');
        const tiempoB = ahora.diff(moment.utc(b.estadoFechaInicio).local(), 'minutes');
        return tiempoB - tiempoA;
      });
    }

    const totalFiltrados = filtrados.length || 1;
    for (const estado in this.movilesPorEstado) {
      this.porcentajesPorEstado[estado] = ((this.movilesPorEstado[estado].length / totalFiltrados) * 100).toFixed(1) + '%';
    }
    const countAsignadoConfirmado = this.movilesPorEstado['ASIGNADO'].length + this.movilesPorEstado['CONFIRMADO'].length;
    this.porcentajesPorEstado['ASIGNADO_CONFIRMADO'] = ((countAsignadoConfirmado / totalFiltrados) * 100).toFixed(1) + '%';
  }

  trackByUuid(index: number, item: MovilDTO): string {
    return item.uuid;
  }

  unsubscribeMqtt() {
    for (let numeroInterno in this.listadoSuscripcionesMovilesMtt) {
      if(this.listadoSuscripcionesMovilesMtt[numeroInterno])
        this.listadoSuscripcionesMovilesMtt[numeroInterno].unsubscribe();
    }
  }

  getDetalleMovil(numeroInterno: string) {
    this.apiService.getDetalleMovil(numeroInterno).subscribe(
      (resp) => this.getDetalleMovilSuccess(resp),
      (error) => this.getDetalleMovilError(error),
    );
  }

  getDetalleMovilSuccess(getDetalleMovilResponseDTO: GetDetalleMovilResponseDTO) {
    console.log('exito detalle movil', getDetalleMovilResponseDTO);
    if(getDetalleMovilResponseDTO.data) {
      const data = getDetalleMovilResponseDTO.data;
      const indice = this.listaMoviles.findIndex(movil => movil.uuid === data.uuid);
      if(indice !== -1) {
        if(this.listaMoviles[indice].estado != data.estado && !this.listadoMovilesEstadosModificadosPorMqttFadeOut.includes(data.uuid)) {
          this.listadoMovilesEstadosModificadosPorMqttFadeOut.push(data.uuid);
          const timeoutId = setTimeout(() => {
            delete this.pendingMqttUpdates[data.uuid];
            const idxFadeOut = this.listadoMovilesEstadosModificadosPorMqttFadeOut.indexOf(data.uuid);
            if (idxFadeOut !== -1) this.listadoMovilesEstadosModificadosPorMqttFadeOut.splice(idxFadeOut, 1);
            const indiceActual = this.listaMoviles.findIndex(movil => movil.uuid === data.uuid);
            if (indiceActual === -1) return;
            if(this.listaMoviles[indiceActual].estado != data.estado && !this.listadoMovilesEstadosModificadosPorMqtt.includes(data.uuid))
              this.listadoMovilesEstadosModificadosPorMqtt.push(data.uuid);
            this.listaMoviles[indiceActual] = data;
          }, 1100);
          this.pendingMqttUpdates[data.uuid] = timeoutId;
        }
          //this.listadoMovilesEstadosModificadosPorMqtt.push(data.uuid);
        this.eventService.publish('MOVIL_ACTUALIZADO_MQTT_EVENT', data);
      }
    }
  }

  private cancelarMqttUpdatesPendientes() {
    for (const uuid in this.pendingMqttUpdates) {
      clearTimeout(this.pendingMqttUpdates[uuid]);
      const idxFadeOut = this.listadoMovilesEstadosModificadosPorMqttFadeOut.indexOf(uuid);
      if (idxFadeOut !== -1) this.listadoMovilesEstadosModificadosPorMqttFadeOut.splice(idxFadeOut, 1);
    }
    this.pendingMqttUpdates = {};
  }

  getDetalleMovilError(error: HttpErrorResponse){
    console.log('error detalle movil', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_MOVIL_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  calcularTime() {
    clearInterval(this.intervaloProgressBar);
    if (this.recarga != 0)
      this.initProgressBar();
  }

  initProgressBar() {
    this.contador = this.recarga;
    this.intervaloProgressBar = setInterval(() => {
      this.contador -= 1000;
      if (this.contador < 0) {
        this.getListaMoviles();
        this.contador = this.recarga;
      }
    }, 1000);
  }

  cambiarEstadoBus(movil: MovilDTO) {
    this.movilService.setMovilSeleccionado(movil);
    this.modalService.show(ModalGestionBusComponent, {
      ignoreBackdropClick: false,
      keyboard: false,
      class: 'modal-dialog-centered modal-xs'
    });
  }

  getListaMovilesError(error: HttpErrorResponse){
    console.log('error lista viajes', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_LISTA_MOVILES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getTiempoRestanteHHmm(fechaFin: string): string {
    const ahora = moment();
    const fin = moment.utc(fechaFin).local();
    const diff = moment.duration(fin.diff(ahora));
    const horas = Math.floor(diff.asHours());
    const minutos = diff.minutes();

    const signo = fin.isBefore(ahora) ? '-' : '';
    return `${signo}${this.pad(Math.abs(horas))}:${this.pad(Math.abs(minutos))}`;
  }

  getTiempoEnEstadoHHmm(fechaInicio: string): string {
    const ahora = moment();
    const inicio = moment.utc(fechaInicio).local();

    if(!inicio.isValid()){
      return "--";
    }

    const diff = moment.duration(ahora.diff(inicio));
    const horas = Math.floor(diff.asHours());
    const minutos = diff.minutes();
    return `${this.pad(Math.abs(horas))}:${this.pad(Math.abs(minutos))}`;
  }

  isTiempoCritico(fechaFin?: string): string | null {

    if (!fechaFin) {
      return null;
    }

    const ahora = moment();
    const fin = moment.utc(fechaFin).local();

    const diff = moment.duration(fin.diff(ahora));
    if (diff.asMinutes() <= 0) {
      return 'clRed';
    } else {
      return 'clGreen';
    }
  }

  private pad(valor: number): string {
    return valor < 10 ? `0${valor}` : `${valor}`;
  }

  get cantidadTodos(): number {
    return this.listaMoviles.length;
  }

  get cantidadTipoMovilA(): number {
    return this.listaMoviles.filter(movil => movil.tipoMovil.codigo.toLocaleLowerCase() === 'a').length;
  }

  get cantidadTipoMovilB(): number {
    return this.listaMoviles.filter(movil => movil.tipoMovil.codigo.toLocaleLowerCase() === 'b').length;
  }

  get cantidadTipoMovilC(): number {
    return this.listaMoviles.filter(movil => movil.tipoMovil.codigo.toLocaleLowerCase() === 'c').length;
  }

  get cantidadTipoMovilBP(): number {
    return this.listaMoviles.filter(movil => movil.tipoMovil.codigo.toLocaleLowerCase() === 'bp').length;
  }

  get cantidadUnidadConecta17(): number {
    return this.listaMoviles.filter(movil => movil.contratoCodigo === 'conecta_17').length;
  }

  get cantidadUnidadConecta18(): number {
    return this.listaMoviles.filter(movil => movil.contratoCodigo === 'conecta_18').length;
  }

  get cantidadElectricos(): number{
    return this.listaMoviles.filter(movil => movil.tipoMovil.combustible === 'ELECTRICO').length;
  }

  get cantidadDiesel(): number{
    return this.listaMoviles.filter(movil => movil.tipoMovil.combustible === 'DIESEL').length;
  }

  private filtrarMovilesPorFiltro(){
    return this.listaMoviles.filter(movil => {
      const coincideCombustible = this.tipoSeleccionado === 'Todos' ||
        movil.tipoMovil.combustible === this.tipoSeleccionado;
      const coincideBusqueda = this.textoBusqueda.trim() === '' || (
        movil.patente?.toLowerCase().includes(this.textoBusqueda.toLowerCase()) ||
        movil.numeroInterno?.toLowerCase().includes(this.textoBusqueda.toLowerCase())
      );
      const coincideUnidad = this.unidadSeleccionada.trim() === 'Todos' ||
        movil.contratoCodigo?.toLowerCase() === this.unidadSeleccionada;
      const coincideTipoBus = this.tipoBus.trim() === 'Todos' ||
        movil.tipoMovil?.codigo?.toLocaleLowerCase() === this.tipoBus.toLocaleLowerCase();

      let coincideNivelEnergia = false;
      if(movil.nivelCombustible == null && movil.estadoCarga == null){
        coincideNivelEnergia = true;
      }else{
        coincideNivelEnergia = (movil.nivelCombustible != null && movil.nivelCombustible >= this.cargaElectricaMinima && movil.nivelCombustible <= this.cargaElectricaMaxima) ||
        (movil.estadoCarga != null && movil.estadoCarga >= this.cargaElectricaMinima && movil.estadoCarga <= this.cargaElectricaMaxima)
      }

      console.log({
        movil : movil.numeroInterno,
        min: this.cargaElectricaMinima,
        electrico: movil.estadoCarga,
        diesel: movil.nivelCombustible,
        max: this.cargaElectricaMaxima,
        coincideNivelEnergia: coincideNivelEnergia
      })

      return coincideCombustible && coincideBusqueda && coincideUnidad && coincideTipoBus && coincideNivelEnergia;
    })
  }

  limpiarFiltros(){
    this.tipoSeleccionado = 'Todos';
    this.unidadSeleccionada = 'Todos';
    this.tipoBus = 'Todos';
    this.textoBusqueda = '';

    this.rangoCargaMin = 0;
    this.rangoCargaMax = 100;

    this.cargaElectricaMinima = 0;
    this.cargaElectricaMaxima = 100;

    // Para recordar el valor anterior
    this.valorMinimoPrevio = 0;
    this.valorMaximoPrevio = 100;
  }

}
